import { render, staticRenderFns } from "./TenantResourceButton.vue?vue&type=template&id=e6100e78"
import script from "./TenantResourceButton.vue?vue&type=script&lang=js"
export * from "./TenantResourceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports